import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject, Renderer2, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService, UserService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OrderService } from '../order.service';
import { Order } from '../order';
import { ReservationService } from '@app/_components/reservation/reservation.service';
import { PromotionOfferService, PromotionOffer, PromotionApplyPreview } from '@app/_components/reservation/promotion-offer.service';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { first } from 'rxjs';
import { LostFoundService } from '@app/_components/lost-found/lost-found.service';
import { PropertyService } from '@app/_components/property/property.service';
import { ReservationCreateComponent } from '@app/_components/reservation/components/reservation-create/reservation-create.component';
import {MsgTemplateData} from '@app/_components/msg-template/msg-template-data';
import { OrderDetailService } from '@app/_components/reservation/components/reservation/order-detail/order-detail.service';
import { LogmanService } from '@app/_components/logman/logman.service';


@Component({
    selector: 'app-order',
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OrderComponent implements OnInit {
	reservation: any;
	referralSources: any[];
	orderStatuses: any[];
	salesManList: any[];
	lostFounds: any[]=[];
	paymentTypes: any[];
	paymentReceivedTypes: any;

	msgVOListUpdated: boolean;
	showCreateReservationPopUp = false;
	isReservationLoaded = false;
	isPopup = false;
	numAdults: any[];
	properties: any[] = [];
	reservations: any[] = [];
  msgTemplateData: MsgTemplateData;
	grandTotals: number;
	totalTaxes: number;
	totalAmounts: number;
	paymentRecieve: number;
	paymentSources: any[]=[];
	applyToList: any[]=[];
	paymentDepositTypes: any[]=[];
	invoiceDetailTypes: any[]=[];
	paymentList: any[]=[];
	visible = false;
	countries: any;
	cardExpiryMonths: any[];
	cardExpiryYears: any[];
	orderInvoiceDetailId: any;
	errorList: any[]=[];
	showValidationErrors = false;
	errorMessages: string;
	salesmen: any[]=[];
	selectedEmailType: any;
	cancelReservationIds: any[]=[];
	orderDetailList: any[]=[];
	orderInvoiceDetailList: any[]=[];
	searchName: any = null;
	isLoadPaymentList = false;
	isUserHaveSalesMen1Role = false;
	isUserHaveSalesMen2Role = false;
	rateFeesDetails = [];
	highlightedPaymentAttemptIndex: number | null = null;

	rateLogOutput;
  rateLosLogOutput;
  upsellLogs: any[] = [];
  upsellLogsLoading = false;
  // ----- Promotion-extension upsell card -----
  promotionOffer: PromotionOffer | null = null;
  promotionOfferLoading = false;

  // Apply confirmation modal
  promotionPreview: PromotionApplyPreview | null = null;
  promotionPreviewLoading = false;
  promotionPreviewVisible = false;
  promotionApplying = false;
  /**
   * Directions selected in the apply modal — for dual-direction offers, the
   * reservationist can pick one or both. Defaults to all still-applicable
   * directions when the modal opens. Single-direction offers leave this with
   * one entry (mirroring the offer's single direction).
   */
  selectedDirections: ('PREV' | 'NEXT')[] = [];

  /** Toggles the "About the Promotion Offer Tool" help popover. */
  promotionHelpVisible = false;
  isUrlCopied = false;
	from: string;
	constructor(
		private primengConfig: PrimeNGConfig,
		private orderService: OrderService,
		private userService: UserService,
		private alertService: AlertService,
		private reservationService: ReservationService,
		private orderDetailService: OrderDetailService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private location1: Location,
		private activatedRoute: ActivatedRoute,
		private lostFoundService: LostFoundService,
		private propertyService: PropertyService,
		private constantService: ConstantService,
		private dialog: MatDialog,
		private router: Router,
		private renderer: Renderer2,
		private logmanService: LogmanService,
		private promotionOfferService: PromotionOfferService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.from = data.from || 'reservations',
			this.reservation = data.reservation,
			this.isPopup = data.isPopup || false,
			this.statuses = orderService.statuses;
			this.referralSources = this.reservationService.referralSources;
			this.orderStatuses = this.reservationService.orderStatuses;
			this.salesManList = this.reservationService.salesManList;
			this.paymentTypes = this.reservationService.paymentTypes;
			this.paymentReceivedTypes = orderService.paymentReceivedTypes;
			this.paymentDepositTypes = orderService.paymentDepositTypes;
			this.invoiceDetailTypes = orderService.invoiceDetailTypes;
    		this.numAdults = this.reservationService.numAdults;
			this.countries = this.constantService.countries;
			this.cardExpiryMonths = this.reservationService.cardExpiryMonths;
			this.cardExpiryYears = this.reservationService.cardExpiryYears;
			this.renderer.addClass(document.body, 'custom-body-class');
	}

	@Input() order: any;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	orderId: number;

	// forms
	form1: UntypedFormGroup;
	form2: UntypedFormGroup;
	form3: UntypedFormGroup;
	form4: UntypedFormGroup;
  @ViewChildren('paymentAttemptRow') paymentAttemptRows!: QueryList<ElementRef<HTMLTableRowElement>>;
	formLoading = false;
	addingOrderInvoiceDetail = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'orderId': [],
		'status': [],
		'ccPremiumPct': [],
		referralSourceId:[],
		creditSaleTo2:[],
		creditSaleTo:[],
		lostFoundId:[]

	};
	validationMessages4 = {
		amount: [{ type: 'required', message: 'Required' }],
		type: [{ type: 'required', message: 'Required' }],
	  };

	validationMessages2 = {
		shortTermRentalId: [{ type: 'required', message: 'Required' }],
		emailAddress: [{ type: 'required', message: 'Required' },
		  { type: 'email', message: 'Not a valid Email' }],
		referralSourceId: [{ type: 'required', message: 'Required' }],
		numAdults: [{ type: 'required', message: 'Required' }],
		numChildren: [{ type: 'required', message: 'Required' }],
		checkOutDate: [{ type: 'required', message: 'Required' }],
		checkInDate: [{ type: 'required', message: 'Required' }],
		firstName: [{ type: 'required', message: 'Required' }],
		lastName: [{ type: 'required', message: 'Required' }],
	  };

	validationMessages3 = {
		reservationId: [{ type: 'required', message: 'Required' }],
		effectiveDate: [{ type: 'required', message: 'Required' }],
		type: [{ type: 'required', message: 'Required' }],
		description: [{ type: 'required', message: 'Required' }],
		privateNotes: [{ type: 'required', message: 'Required' }],
		paymentConfirmId: [],
		paymentProcessDate: [{ type: 'required', message: 'Required' }],
		paymentType: [{ type: 'required', message: 'Required' }],
		paymentProcessAmount: [{ type: 'required', message: 'Required' }],
		amount: [],
		paymentSourceAccountIdentifier: [],
		paymentTransactionConfirmNumber: [],
		paymentProceedsDepositedToAccountIdentifier: [],
		paymentGatewayProvider: [],
		billingName: [{ type: 'required', message: 'Required' }],
		billingStreetAddress: [{ type: 'required', message: 'Required' }],
		billingCity: [{ type: 'required', message: 'Required' }],
		billingState: [{ type: 'required', message: 'Required' }],
		billingPostalCode: [{ type: 'required', message: 'Required' }],
		billingCountry: [{ type: 'required', message: 'Required' }],

	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.paymentList = [];
		this.formBuild();
		this.formBuildForAddNewReservation();
		this.formBuildForInvoiceOrderDetail();
		this.formBuildForInvoiceOrderDetailUpdateAndDelete();
		this.fetchProperties();

		if(this.reservation == null && this.reservation == undefined){
			this.activatedRoute.params.subscribe(params =>
			   {
				   this.orderId = params.orderId; // (+) converts string 'id' to a number
				   this.formTitle = "Edit Order";
			   });
			   if(this.orderId != null && this.orderId != undefined){
				   this.findOrderById();
			   }
	   }else{
		   this.orderId = this.reservation?.orderId;
		   if(this.orderId == undefined && this.orderId == null){
			this.orderId = this.reservation?.order?.orderId;
		   }
		   if(this.orderId != null && this.orderId != undefined){
			   this.findOrderById();
		   }
	}
}

findOrderById() {
	this.formLoading = true;
	this.orderService.findById(this.orderId)
		.pipe(first())
		.subscribe(
			res => {
				console.log('findReservationById: ' + JSON.stringify(res));
				this.order = res.data.order;
				this.findReservationById();
				this.fetchSalesmen();
				this.form1.patchValue({
					referralSourceId: this.order?.referralSourceId,
					status: this.order?.status,
				});

				// this.order?.reservations.forEach(reservation => {
				// 	if (reservation?.reservationStatus == "OX") {
				// 		this.cancelReservationIds.push(reservation?.reservationId);
				// 	}
				// });

				// this.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
				// 	if (!this.cancelReservationIds.includes(orderDetail?.reservationId)) {
				// 		this.orderDetailList.push(orderDetail);
				// 	}
				// });
				// this.order.orderInvoice.orderDetails = this.orderDetailList;

				// this.order?.orderInvoice?.orderInvoiceDetails.forEach(orderInvoiceDetail => {
				// 	if (!this.cancelReservationIds.includes(orderInvoiceDetail?.reservationId)) {
				// 		this.orderInvoiceDetailList.push(orderInvoiceDetail);
				// 	}
				// });
				// this.order.orderInvoice.orderInvoiceDetails = this.orderInvoiceDetailList;

				  this.grandTotals = this.grandTotal();
				  this.totalTaxes = this.totalTax();
				  this.totalAmounts = this.totalAmount();
				  this.paymentRecieve = this.outStandingBalance();
				  this.order?.paymentSources.forEach(paymentSource => {
					let data1 = paymentSource?.paymentType+" "+paymentSource?.creditCardType+" "+paymentSource?.billingName+" "+paymentSource?.creditCardNumber+" "+paymentSource?.creditCardExpirationMonth+"/"+paymentSource?.creditCardExpirationYear;
					let data = { paymentSource: paymentSource, value: paymentSource?.paymentSourceId, name: data1.toString()};
					this.paymentSources.push(data);
				});

				this.order?.orderInvoice?.orderInvoiceDetails.forEach(orderInvoiceDetail => {
					if(orderInvoiceDetail?.type == 2 || orderInvoiceDetail?.type == 4 || orderInvoiceDetail?.type == 5 || orderInvoiceDetail?.type == 6 || orderInvoiceDetail?.type == 7 || orderInvoiceDetail?.type == 8 ||  orderInvoiceDetail?.type == 9){
						if(orderInvoiceDetail?.reservationId == null){
							orderInvoiceDetail.reservationId = this.order.reservations[0].reservationId;
						}
						this.paymentList.push(orderInvoiceDetail);
						this.isLoadPaymentList = true;
					}
				});


				// this.mapReservation(this.reservation);
			},
			err => {
				console.log('error In findReservationById is: ' + JSON.stringify(err));
				this.formLoading = false;
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your reservation: ' + err.message, life: 3000 });
			},
			() => { this.formLoading = false; });
}



	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.orderId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		// Guard: prevent duplicate POSTs when the server is slow or returns 504
		if (this.formLoading) { return; }
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.orderService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.order = res.data.order;
						this.doAdd.emit(this.order);
					},
					(err: any) => {
						console.log('order-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		// Guard: prevent duplicate PATCHes when the server is slow or returns 504
		if (this.formLoading) { return; }
		console.log('order: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.orderService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.order = res.data.order;
						// this.doUpdate.emit(this.order);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.orderService.delete(this.order.orderId)
				.subscribe(
					(res: any) => {
						console.log('order-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.order);
					},
					(err: any) => {
						console.log('order-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	/*********
	 * Lazy Load All Data
	 *
	 */
	getLostFound() {
		this.lostFoundService.findByReservationId(this.reservation.reservationId)
			.pipe(first())
			.subscribe(
				res => {
					console.log('findReservationById: ' + JSON.stringify(res));
					this.lostFounds = res.data.lostFounds;
				},
				err => {
					console.log('error In findReservationById is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your reservation: ' + (err?.error?.message || err?.message || 'server error'), life: 5000 });
				},
				() => { this.formLoading = false; });
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			orderId: [this.orderId],
			status: [],
			referralSourceId: [],
			creditSaleTo2: [],
			creditSaleTo: [],
			lostFoundId: [],
			orderInvoice: this.formBuilder.group({
				ccPremiumPct: [],
			}),
		});
	}

	formBuildForInvoiceOrderDetail(){
		this.form3 = this.formBuilder.group({
			orderInvoiceId: [],
			reservationId: [],
			orderInvoiceDetailId: [],
			amount: ['',Validators.required],
			type: ['',Validators.required],
			description: [],
			effectiveDate: [],
			enteredByUserId: [],
			privateNotes: [],
			paymentConfirm: this.formBuilder.group({
				paymentConfirmId: [],
				paymentProcessDate: [],
				billingName: [],
				paymentSourceAccountIdentifier: [],
				paymentType: [],
				paymentTransactionConfirmNumber: [],
				paymentProceedsDepositedToAccountIdentifier: [],
			}),
		});
	}

	formBuildForInvoiceOrderDetailUpdateAndDelete(){
		this.form4 = this.formBuilder.group({
			orderInvoiceId: [],
			reservationId: ['',Validators.required],
			orderInvoiceDetailId: [],
			enteredByUserId: [],
			amount: [],
			type: ['',Validators.required],
			description: ['',Validators.required],
			effectiveDate: ['',Validators.required],
			privateNotes: ['',Validators.required],
			paymentConfirm: this.formBuilder.group({
				paymentConfirmId: [],
				paymentProcessDate: ['',Validators.required],
				paymentType: ['',Validators.required],
				paymentProcessAmount: ['',Validators.required],
				paymentSourceAccountIdentifier: [],
				paymentTransactionConfirmNumber: [],
				paymentProceedsDepositedToAccountIdentifier: [],
				paymentGatewayProvider: [],
				billingName: [],
				billingStreetAddress: [],
				billingCity: [],
				billingState: [],
				billingPostalCode: [],
				billingCountry: ['US'],
				paymentSource: this.formBuilder.group({
					payorUserId:[],
					paymentSourceId: [],
					paymentType: [],
					billingName: [],
					billingStreetAddress: [],
					billingCity: [],
					billingState: [],
					billingPostalCode: [],
					billingCountry: ['US'],
					achBankName: [],
					achBankAccountNumber: [],
					achRoutingNumber: [],
					achAccountType: [],
					achCheckNumber: [],
					achMicrData: [],
					achBranchSortCode: [],
					creditCardType: [],
					creditCardNumber: [],
					creditCardExpirationMonth: [],
					creditCardExpirationYear: [],
					creditCardSecurityCode: [],
				})

			})
		});
	}


  highlightPaymentAttemptFor(payment: any): void {
    if (!this.order?.paymentAttempts || !payment?.paymentConfirm?.paymentConfirmId) {
      return;
    }

    const targetId = payment.paymentConfirm.paymentConfirmId;
    const matchIndex = this.order.paymentAttempts.findIndex(
      (attempt: any) => attempt?.paymentConfirmId === targetId
    );

    if (matchIndex >= 0) {
      this.highlightedPaymentAttemptIndex = matchIndex;

      setTimeout(() => {
        const rows = this.paymentAttemptRows?.toArray?.() || [];
        const rowEl = rows[matchIndex]?.nativeElement;
        if (rowEl && typeof rowEl.scrollIntoView === 'function') {
          rowEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });

      setTimeout(() => {
        this.highlightedPaymentAttemptIndex = null;
      }, 1500);
    }
  }

	formBuildForAddNewReservation() {
		this.form2 = this.formBuilder.group({
			shortTermRentalId: ['', Validators.required],
			referralSourceId: ['', Validators.required],
			numAdults: [2, Validators.required],
			numChildren: [0, Validators.required],
			checkOutDate: ['', Validators.required],
			checkInDate: ['', Validators.required],
			guestProfile: this.formBuilder.group({
			  firstName: ['', Validators.required],
			  lastName: ['', Validators.required],
			  emailAddress: ['', Validators.compose([Validators.required, Validators.email])],
			  guestCompanions: new UntypedFormArray([]),
			}),
		  });
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.order.orderDate = moment(this.order.orderDate).toDate();
	}

	gotoReservation() {
		this.location1.go('/reservations');
		this.router.navigate(['reservations']);
	}

	closePopUp() {
		const url = this.from === 'reservation-in-out-list' ? '/reservations-in-out-list' : '/reservations';
		this.location1.go(url);
	}

	//
	getPaymentTypeName(paymentAttempt: any) {
		if (paymentAttempt?.paymentType != null && paymentAttempt?.paymentType != undefined) {
			const status = this.paymentTypes.find((e: any) => e.value == paymentAttempt?.paymentType);
			return status.name;
		}
		else {
			return '';
		}
	}

	/**
	 * Deferred-capture UI indicator. An AO+A row is "awaiting capture" only while
	 * no PRIOR_AUTH_CAPTURE row exists for the same gateway transaction id. Once
	 * the scheduler (or an admin via "Authorize Capture") inserts a PC row sharing
	 * the same paymentTransactionConfirmNumber, the original AO row no longer
	 * needs the badge — the auth has been (or attempted to be) captured.
	 *
	 * Match is on transaction id, mirroring the backend NOT EXISTS check in
	 * PaymentConfirmDAO.findPendingCaptures so UI and scheduler agree on what
	 * "still pending" means.
	 */
	isAwaitingCapture(paymentAttempt: any): boolean {
		if (!paymentAttempt) return false;
		if (paymentAttempt.paymentCreditCardRequestedTransactionType !== 'AO') return false;
		if (paymentAttempt.paymentResultIndicator !== 'A') return false;
		const authTxnId = paymentAttempt.paymentTransactionConfirmNumber;
		if (!authTxnId) return false;
		const attempts: any[] = this.order?.paymentAttempts || [];
		return !attempts.some(a => a
			&& a.paymentCreditCardRequestedTransactionType === 'PC'
			&& a.paymentTransactionConfirmNumber === authTxnId);
	}

	/**
	 * Controls the "Capture & Sync" button. Returns true for two row shapes:
	 *  • AO+A with no matching PC row yet — auth placed, not yet captured on our side.
	 *  • PC+D or PC+E — the scheduler attempted capture and the gateway rejected it
	 *    (typical RRC_3_16 when propertyState was missing). The underlying auth is
	 *    still live at the gateway (auths expire ~7 days); admin can re-attempt the
	 *    capture via our app without going to the Authorize.net portal.
	 *
	 * The backend capturePriorAuthAndSync() accepts both row shapes (AO+A and PC+D/E).
	 */
	canCaptureAndSync(paymentAttempt: any): boolean {
		if (!paymentAttempt) return false;
		const type   = paymentAttempt.paymentCreditCardRequestedTransactionType;
		const result = paymentAttempt.paymentResultIndicator;
		if (type === 'AO' && result === 'A') return this.isAwaitingCapture(paymentAttempt);
		if (type === 'PC' && (result === 'D' || result === 'E')) return true;
		return false;
	}

	// Tracks which row's reconcile call is currently in flight so the row's
	// button can show "Reconciling…" + be disabled while we wait for the API.
	reconcilingPaymentConfirmId: number | null = null;

	// Tracks which row's Capture & Sync call is in flight (debounce guard).
	capturingPaymentConfirmId: number | null = null;

	// Controls the "How does this work?" payment help dialog.
	showPaymentHelp = false;

	/**
	 * Show the "Reconcile Captured" button for two row shapes:
	 *  • AO + A with no matching PC row yet (auth approved, capture not yet
	 *    persisted on our side; admin already captured manually at the gateway).
	 *  • PC + D / PC + E (scheduler attempted capture but the gateway rejected,
	 *    typically RRC_3_16; admin has since captured manually at the gateway).
	 * Already-reconciled rows (PC + A) and credit-only / void rows never show it.
	 */
	canReconcileCaptured(paymentAttempt: any): boolean {
		if (!paymentAttempt) return false;
		const type   = paymentAttempt.paymentCreditCardRequestedTransactionType;
		const result = paymentAttempt.paymentResultIndicator;
		if (type === 'AO' && result === 'A') return this.isAwaitingCapture(paymentAttempt);
		if (type === 'PC' && (result === 'D' || result === 'E')) return true;
		return false;
	}

	/**
	 * Calls the backend reconcile endpoint. Confirms with the user first because
	 * the action writes an irreversible (PC, A) row + triggers downstream
	 * cascade (E4 / NACHA / owner stmt / QBO sync via the same path the
	 * scheduler uses on auto-capture success).
	 */
	onReconcileCaptured(paymentAttempt: any): void {
		const paymentConfirmId = paymentAttempt?.paymentConfirmId;
		const authnetTxnId     = paymentAttempt?.paymentTransactionConfirmNumber;
		if (!paymentConfirmId || !authnetTxnId) {
			this.alertService.error('Cannot reconcile: missing paymentConfirmId or transaction id.');
			return;
		}
		this.confirmationService.confirm({
			header: 'Reconcile Captured',
			message: `This will verify with Authorize.net that transaction ${authnetTxnId} is captured and mark `
				+ `paymentConfirm ${paymentConfirmId} as (PC, A). Continue?`,
			icon: 'fa fa-exclamation-triangle',
			acceptLabel: 'Reconcile',
			rejectLabel: 'Cancel',
			accept: () => {
				this.reconcilingPaymentConfirmId = paymentConfirmId;
				this.reservationService.markCapturedFromAuthnet(paymentConfirmId, authnetTxnId)
					.subscribe(
						(res: any) => {
							this.reconcilingPaymentConfirmId = null;
							const msg = res?.message || 'Reconciled.';
							if (res?.statusCode === 200) {
								this.alertService.success(msg);
								// Refresh the order so the payment list reflects the new (PC, A) state.
								window.location.reload();
							} else {
								this.alertService.error(msg);
							}
						},
						(err: any) => {
							this.reconcilingPaymentConfirmId = null;
							// The global ErrorInterceptor (_helpers/error.interceptor.ts) unwraps
							// non-401 HTTP errors into a plain string. Handle both that shape and
							// the raw HttpErrorResponse so the real backend message reaches the user.
							let msg: string | null = null;
							if (typeof err === 'string') {
								msg = err;
							} else if (err && typeof err === 'object') {
								msg = err?.error?.data?.result?.message
									|| err?.error?.message
									|| err?.message
									|| (typeof err?.error === 'string' ? err.error : null);
							}
							this.alertService.error(msg || 'Reconcile failed.');
						});
			}
		});
	}
	/**
	 * Captures a prior auth through our app and triggers the downstream sync
	 * (E4, NACHA, owner stmt, QBO). Unlike "Reconcile Captured" (which requires
	 * the admin to have already captured at the Authorize.net dashboard), this
	 * submits the capture directly to the gateway via POST /payment/capturePriorAuthAndSync.
	 */
	onCaptureAndSync(paymentAttempt: any): void {
		const paymentConfirmId = paymentAttempt?.paymentConfirmId;
		if (!paymentConfirmId) {
			this.alertService.error('Cannot capture: missing paymentConfirmId.');
			return;
		}
		if (this.capturingPaymentConfirmId === paymentConfirmId) { return; }
		this.confirmationService.confirm({
			header: 'Capture & Sync',
			message: `Capture auth for paymentConfirm ${paymentConfirmId} through the gateway now and sync downstream (E4, NACHA, owner statement, QBO)?`,
			icon: 'fa fa-exclamation-triangle',
			acceptLabel: 'Capture & Sync',
			rejectLabel: 'Cancel',
			accept: () => {
				this.capturingPaymentConfirmId = paymentConfirmId;
				this.orderService.capturePriorAuthAndSync(paymentConfirmId)
					.subscribe(
						(res: any) => {
							this.capturingPaymentConfirmId = null;
							const msg = res?.message || 'Captured and synced.';
							if (res?.statusCode === 200) {
								this.alertService.success(msg);
								window.location.reload();
							} else {
								this.alertService.error(msg);
							}
						},
						(err: any) => {
							this.capturingPaymentConfirmId = null;
							let msg: string | null = null;
							if (typeof err === 'string') {
								msg = err;
							} else if (err && typeof err === 'object') {
								msg = err?.error?.message
									|| err?.message
									|| (typeof err?.error === 'string' ? err.error : null);
							}
							this.alertService.error(msg || 'Capture & Sync failed.');
						});
			}
		});
	}


	sendGuestComm(stage: number) {
		this.formLoading = true;
		this.reservationService.sendGuestCommunication(this.reservations[0]?.reservationId, stage)
			.pipe(first())
			.subscribe(
				res => {
					this.msgVOListUpdated = !this.msgVOListUpdated;
					this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					console.log('findReservationById: ' + JSON.stringify(res));
				},
				err => {
					// Do NOT reset formLoading on error — a 504 means the communication may have
					// already been sent. Keep button disabled to prevent duplicate sends.
					console.log('sendGuestCommunication FAIL: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Communication send may have completed. Please refresh before retrying.', life: 3000 });
				},
				() => { this.formLoading = false; });
	}

	grandTotal(){
		let total = 0
		if(this.order?.orderInvoice?.orderDetails.length > 0){
			this.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
				total += orderDetail?.total
			});
		}
		return total;
	}

	outStandingBalance(){
		let paymentRecieved = 0
		if(this.order?.orderInvoice?.orderInvoiceDetails.length > 0){
			this.order?.orderInvoice?.orderInvoiceDetails.forEach(orderInvoiceDetail => {
				if(orderInvoiceDetail?.type == 2){
					paymentRecieved += orderInvoiceDetail?.amount
				}
			});
		}
		return paymentRecieved;
	}

	totalTax(){
		let total = 0
		if(this.order?.orderInvoice?.orderDetails.length > 0){
			this.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
				total += orderDetail?.tax
			});
		}
		return total;
	}
	totalAmount(){
		let total = 0;
		if(this.order?.orderInvoice?.orderDetails.length > 0){
			this.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
				total += orderDetail?.subTotal
			});
		}
		return total;
	}

	getPropertyCode(orderDetail: any) {
		if (orderDetail?.reservationId) {
			const status = this.reservations.find((e: any) => e.reservationId == orderDetail.reservationId);
			return status?.shortTermRental?.propertyCode;
		}
		else {
			return '';
		}
	}

	openCreateReservationPopUp() {
		const dialogConfig = new MatDialogConfig();

		const data = {
			orderId: this.order?.orderId,
			referralSourceId: this.order?.referralSourceId,
			numAdults: this.reservations[0]?.numAdults,
			numChildren: this.reservations[0]?.numChildren,
			checkOutDate: moment.utc(this.reservations[0]?.checkOutDate).format('MM/DD/YYYY'),
			checkInDate: moment.utc(this.reservations[0]?.checkInDate).format('MM/DD/YYYY'),
			guestProfile: {
				firstName: this.reservations[0]?.guestProfile?.firstName,
				lastName: this.reservations[0]?.guestProfile?.lastName,
				emailAddress: this.reservations[0]?.guestProfile?.emailAddress,
			},
		};
		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "40vw";
		dialogConfig.width = "20vw";
		dialogConfig.disableClose = true;
		// dialogConfig.maxHeight = "50vw";
		// dialogConfig.height = "95vh";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			showCloseButton: true,
			reservation: data,
			openNewTab: false
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ReservationCreateComponent, dialogConfig);

		 // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		 dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.reloadPage();
				this.ngOnInit()

				// close the dialogBox
				dialogRef.close();
			});
	}

	reloadPage() {
		window.location.reload();
	}

	addOrderInvoiceDetail(payment: any) {
		console.log('findReservationById: ' + JSON.stringify(this.form3.value));
		// stop here if form is invalid
		this.form3.markAllAsTouched();
		if (this.form3.invalid) {
			return;
		}
		if (this.addingOrderInvoiceDetail) {
			return;
		}
		if(this.form3.value.reservationId == null && payment.reservationId == null){
			this.form3.value.reservationId = this.order.reservations[0].reservationId;
		}

		const data = {
			orderInvoiceId: this.order?.orderInvoice?.orderInvoiceId,
			reservationId: this.form3.value.reservationId != null ? this.form3.value.reservationId : payment.reservationId,
			amount: -this.form3.value.amount,
			type: this.form3.value.type,
			description: this.form3.value.description,
			effectiveDate: this.form3.value.effectiveDate,
			enteredByUserId: 0,
			privateNotes: this.form3.value.privateNotes,
			paymentConfirm: {
				paymentProcessDate: this.form3.value.paymentConfirm.paymentProcessDate,
				paymentProcessAmount: -this.form3.value.amount,
				billingName: this.form3.value.paymentConfirm.billingName,
				paymentSourceAccountIdentifier: this.form3.value.paymentConfirm.paymentSourceAccountIdentifier,
				paymentType: this.form3.value.paymentConfirm.paymentType,
				paymentTransactionConfirmNumber: this.form3.value.paymentConfirm.paymentTransactionConfirmNumber,
				paymentProceedsDepositedToAccountIdentifier: this.form3.value.paymentConfirm.paymentProceedsDepositedToAccountIdentifier,
			},
		};

		try {
			this.addingOrderInvoiceDetail = true;
			this.orderService.orderInvoiceDetailAdd(data)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						// Keep addingOrderInvoiceDetail true until reload (avoids double submit if reload is slow)
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Payment added successfully" });
						this.reloadPage();
					},
					(err: any) => {
						// Do NOT reset addingOrderInvoiceDetail on error — a 504 means the backend
						// may have already saved the payment.  Keep the flag true to block re-submit.
						// The error interceptor will surface a "check before resubmitting" warning.
						console.log('order-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {
						this.addingOrderInvoiceDetail = false;
					 });
		} catch (error) {
			this.addingOrderInvoiceDetail = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	  fetchProperties() {
		if (this.properties && this.properties.length > 0) return; // already loaded
		try {
			this.propertyService.findAllSummaryWithStatusActiveAndSuspended()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	fetchSalesmen() {
		try {
			this.userService.getSalesmen()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.salesmen = res.data.salesmen;
						this.salesmen.forEach((value, index) => {
							if(this.order?.creditSaleTo != null && this.order?.creditSaleTo != undefined && this.order?.creditSaleTo != ""){
								if(this.salesmen[index].userId == this.order?.creditSaleTo?.userId){
									this.isUserHaveSalesMen1Role = true;
								}
							}
							if(this.order?.creditSaleTo2 != null && this.order?.creditSaleTo2 != undefined && this.order?.creditSaleTo2 != ""){
								if(this.salesmen[index].userId == this.order?.creditSaleTo2?.userId){
									this.isUserHaveSalesMen2Role = true;
								}
							}
							this.salesmen[index].fullName = [value.firstName, value.lastName].filter(s => s).join(' ');
						});
						if(!this.isUserHaveSalesMen1Role && this.order?.creditSaleTo != null && this.order?.creditSaleTo != undefined && this.order?.creditSaleTo != ""){
							this.order.creditSaleTo.fullName = [this.order?.creditSaleTo?.firstName, this.order?.creditSaleTo?.lastName].filter(s => s).join(' ');
							this.salesmen.push(this.order.creditSaleTo);
						}

						if(!this.isUserHaveSalesMen2Role && this.order?.creditSaleTo2 != null && this.order?.creditSaleTo2 != undefined && this.order?.creditSaleTo2 != ""){
							this.order.creditSaleTo2.fullName = [this.order?.creditSaleTo2?.firstName, this.order?.creditSaleTo2?.lastName].filter(s => s).join(' ');
							this.salesmen.push(this.order.creditSaleTo2);
						}

						this.form1.patchValue({
							creditSaleTo: this.order?.creditSaleTo?.userId,
							creditSaleTo2: this.order?.creditSaleTo2?.userId,
						});
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	getReservationlist(reservationUpdated: any){
		if(this.reservations.length > 0){
			var reservationExists = false;
			this.reservations.forEach((reservationOld, index) => {
				if(reservationOld.reservationId == reservationUpdated.reservationId){
					reservationExists = true;
					this.reservations[index] = reservationUpdated;
				}
			});
			if(reservationExists == false){
				this.reservations.push(reservationUpdated);
			}
		}else{
			this.reservations.push(reservationUpdated);
		}
		if (this.reservations.length == this.order.reservations.length) {
			this.reservations.forEach( (reservation) => {
				const applyToData = {
					value: reservation?.reservationId,
					name: reservation?.shortTermRental?.propertyCode,
					label: reservation?.shortTermRental?.propertyCode + ' #' + reservation?.reservationId + ' (' + moment(reservation?.checkInDate).format('MM-DD-YYYY') + ' to ' + moment(reservation?.checkOutDate).format('MM-DD-YYYY') + ')',
				}
				this.applyToList.push(applyToData);
			  });
		}
    this.setTemplateData(this.reservations[0]);
    this.isReservationLoaded = true;
    this.loadUpsellLogs(this.reservations[0]?.reservationId);
	this.loadPromotionOffer(this.reservations[0]?.reservationId);
  }

  setTemplateData(res: any) {
    this.msgTemplateData = new MsgTemplateData();
    let firstName = res?.guestProfile?.firstName ? res?.guestProfile?.firstName : '';
    let lastName = res?.guestProfile?.lastName ? res?.guestProfile?.lastName : '';
    this.msgTemplateData.fullName =  firstName + ' ' + lastName;
    this.msgTemplateData.firstName = firstName;
    this.msgTemplateData.reservationId = res?.reservationId;
    this.msgTemplateData.resortName = res?.shortTermRental?.propertyCode;
    this.msgTemplateData.adrDevelopmentName = res?.shortTermRental?.developmentName;
    this.msgTemplateData.confirmationNumber = res?.reservationConfId;
    this.msgTemplateData.emailAddress = res?.guestProfile?.emailAddress;
    this.msgTemplateData.mobilePhone = res?.guestProfile?.mobilePhone;
    this.msgTemplateData.checkInDateTime = res?.checkInDate;
    this.msgTemplateData.checkOutDateTime = res?.checkOutDate;
    return this.msgTemplateData;
  }

	selectEmailContract() {
		const data = {
			"reservationId": this.reservations[0].reservationId,
			"orderId": this.order.orderId
		}

		this.orderService.emailContract(data)
			.subscribe(
				(res: any) => {
					console.log('property-update SUCCESS: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
				},
				(err: any) => {
					console.log('property-update FAIL: ' + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { this.formLoading = false; });
	}

	selectEmailInvoice() {
		const data = {
			"reservationId": this.reservations[0].reservationId,
			"orderId": this.order.orderId
		}

		this.orderService.emailInvoice(data)
			.subscribe(
				(res: any) => {
					console.log('property-update SUCCESS: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
				},
				(err: any) => {
					console.log('property-update FAIL: ' + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { this.formLoading = false; });
	}

	selectEmailCheckInDetails() {
		const data = {
			"reservationId": this.reservations[0].reservationId,
			"orderId": this.order.orderId
		}
		this.orderService.emailCheckInDetails(data)
			.subscribe(
				(res: any) => {
					console.log('property-update SUCCESS: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
				},
				(err: any) => {
					console.log('property-update FAIL: ' + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { this.formLoading = false; });
	}

	selectEmailRentalCarConfirmation() {
		const data = {
			"reservationId": this.reservations[0].reservationId,
			"orderId": this.order.orderId
		}
		this.orderService.emailRentalCarConfirmation(data)
			.subscribe(
				(res: any) => {
					console.log('property-update SUCCESS: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
				},
				(err: any) => {
					console.log('property-update FAIL: ' + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { this.formLoading = false; });
	}

	sendReservationEmail(){
		this.onChange(this.selectedEmailType);
	}

	onChange(event: any){
		if(event === "contract"){
			this.selectEmailContract();
		}
		if(event === "invoice"){
			this.selectEmailInvoice();
		}
		if(event === "checkInDetails"){
			this.selectEmailCheckInDetails();
		}
		if(event === "rentalCar"){
			this.selectEmailRentalCarConfirmation();
		}
	}

	onChangeSetEmailType(event: any){
		if(event === "contract"){
			this.selectedEmailType = "contract";
		}
		if(event === "invoice"){
			this.selectedEmailType = "invoice";
		}
		if(event === "checkInDetails"){
			this.selectedEmailType = "checkInDetails";
		}
		if(event === "rentalCar"){
			this.selectedEmailType = "rentalCar";
		}
	}

	getApplyToList(reservationId: any , key ='name') {
		if (reservationId) {
			const status = this.applyToList.find((e: any) => e.value == reservationId);
			return status?.[key];
		}
		else {
			return '';
		}
	}

	getPaymentReceivedType(paymentType: any) {
		if (paymentType) {
			const status = this.paymentReceivedTypes.find((e: any) => e.value == paymentType);
			return status?.name;
		}
		else {
			return '';
		}
	}

	getPaymentDepositType(paymentProceedsDepositedToAccountIdentifier: any) {
		if (paymentProceedsDepositedToAccountIdentifier) {
			const status = this.paymentDepositTypes.find((e: any) => e.value == paymentProceedsDepositedToAccountIdentifier);
			return status?.name;
		}
		else {
			return '';
		}
	}

	getTypeName(type: any) {
		if (type) {
			const status = this.invoiceDetailTypes.find((e: any) => e.value == type);
			return status?.name;
		}
		else {
			return '';
		}
	}

  isVoidAllowed(payment: any){
    return payment && payment.paymentConfirm && payment.paymentConfirm.paymentType && payment.paymentConfirm.paymentType === 'CR'
      && payment.type && payment.type === 2;

  }

  isSplitAllowed(payment: any){
    return payment && payment.type && (payment.type === 2 || payment.type === 4);
  }

  splitPayment(payment: any, event: any){
    event.stopPropagation();
    try {
      this.formLoading = true;
      // set contract data into form contract

      let paymentData = {
        voidOrderInvoiceDetailId : payment.orderInvoiceDetailId
      };

      this.confirmationService.confirm({
        message: 'Are you sure you want to split this transactions to confirm reservations? ',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          try {
            // stop here if form is invalid
            this.formLoading = true;
            this.reservationService.splitPayment(this.orderId, payment.orderInvoiceDetailId)
              .subscribe(
                (res: any) => {
                  if (res.statusCode === 400) {
                    this.confirmationService.confirm({
                      header: 'Split Payment Error',
                      message: res.message,
                      icon: 'fa fa-exclamation-triangle',
                      rejectVisible: false,
                      acceptLabel: 'Close',
                      accept: () => {
                        this.formLoading = false;
                        this.doRefreshOrder();
                      }
                    });
                  }else{
                    this.messageService.add({severity: 'success', summary: 'Successful', detail: 'Transaction splited successfully. for orderInvoiceDetailId#' + payment.orderInvoiceDetailId, life: 3000});
                    this.formLoading = false;
                    this.doRefreshOrder();
                  }
                },
                (err: any) => {
                  // Do NOT reset formLoading on error — keep button disabled to block re-submit after 504.
                },
                () => {
                  this.formLoading = false;
                });
          } catch (error) {
            console.log('Form Invalid: ' + JSON.stringify(error));
            this.alertService.error(error);
            this.formLoading = false;
          }
        },
        reject: () => {
          this.messageService.add({severity: 'info', summary: 'Canceled', detail: 'Split canceled.', life: 3000});
          this.formLoading = false;
        }
      });

    } catch (error) {
      this.formLoading = false;
    }

  }

  voidPayment(payment: any, event: any) {
    event.stopPropagation();
    try {
      this.formLoading = true;
      // set contract data into form contract

      let paymentData = {
        voidOrderInvoiceDetailId : payment.orderInvoiceDetailId
      };

      this.confirmationService.confirm({
        message: 'Are you sure you want to void this transactions? ',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          try {
            // stop here if form is invalid
            this.formLoading = true;
            this.reservationService.makeVoidPaymentByAdmin(paymentData)
              .subscribe(
                (res: any) => {
                  if (res.data?.reservationSummary?.reservationApiList[0]?.status === 'INVALID') {
                    this.confirmationService.confirm({
                      header: 'Payment Error',
                      message: res.data?.reservationSummary?.reservationApiList[0]?.errors[0]?.message,
                      icon: 'fa fa-exclamation-triangle',
                      rejectVisible: false,
                      acceptLabel: 'Close',
                      accept: () => {
                        this.formLoading = false;
                        this.doRefreshOrder();
                      }
                    });
                  }else{
                    this.messageService.add({severity: 'success', summary: 'Successful', detail: 'Transaction voided successfully. for orderInvoiceDetailId#' + payment.orderInvoiceDetailId, life: 3000});
                    this.formLoading = false;
                    this.doRefreshOrder();
                  }
                },
                (err: any) => {
                },
                () => {
                  this.formLoading = false;
                });
          } catch (error) {
            console.log('Form Invalid: ' + JSON.stringify(error));
            this.alertService.error(error);
            this.formLoading = false;
          }
        },
        reject: () => {
          this.messageService.add({severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000});
          this.formLoading = false;
        }
      });

    } catch (error) {
      this.formLoading = false;
    }
  }

	openPopUpPaymentSource(payment: any, event: any){
		event.stopPropagation();
		this.form4.reset();
		// Guard: OTA CV entries may have no paymentConfirm record yet. Initialize an
		// empty shell so the edit dialog opens and the user can fill in the amount.
		if (!payment.paymentConfirm) {
			payment.paymentConfirm = {};
		}
		if (payment.paymentConfirm.paymentProcessDate) {
			payment.paymentConfirm.paymentProcessDate = moment(payment.paymentConfirm.paymentProcessDate).toDate();
		}
		if (payment.effectiveDate) {
			payment.effectiveDate = moment(payment.effectiveDate).toDate();
		}
		this.orderInvoiceDetailId = payment.orderInvoiceDetailId;
		this.form4.patchValue(payment);
		this.visible = true;
	}

	updateInvoiceOrder(){
		// Guard: prevent duplicate PATCHes when the server is slow or returns 504
		if (this.formLoading) { return; }
		try {
			// stop here if form is invalid
			this.form4.markAllAsTouched();
			if (this.form4.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form4.value));
			console.log('property-add post: ' + JSON.stringify(this.form4.value.paymentConfirm));
			console.log('property-add post: ' + JSON.stringify(this.form4.value.paymentConfirm.paymentSource));
			// if (this.form4.invalid) {
			// 	return;
			// }
			if ((this.form4.value.paymentConfirm.paymentProcessAmount == null && this.form4.value.paymentConfirm.paymentProcessAmount == undefined && this.form4.value.paymentConfirm.paymentProcessAmount == "")) {
				return;
			}
			if ((this.form4.value.paymentConfirm.paymentType == null && this.form4.value.paymentConfirm.paymentType == undefined && this.form4.value.paymentConfirm.paymentType == "")) {
				return;
			}
			if ((this.form4.value.paymentConfirm.paymentProcessDate == null && this.form4.value.paymentConfirm.paymentProcessDate == undefined && this.form4.value.paymentConfirm.paymentProcessDate == "")) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form4.value));
			this.form4.value.paymentConfirm.paymentSource.payorUserId =this.form4.value.enteredByUserId;
			// this.form4.value.amount = -this.form4.value.paymentConfirm.paymentProcessAmount;
			this.formLoading = true;

			this.orderService.updateOrderInvoiceDetail(this.form4.value)
				.subscribe(
					(res: any) => {
						this.formLoading = false;
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.reloadPage();
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Update successfully" });
						this.visible = false;
					},
					(err: any) => {
						// Do NOT reset formLoading on error — a 504 means the backend may have
						// already committed the update. Keep formLoading=true to block re-submit.
						console.log('order-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	closeDialog(){
		this.visible = false;
	}

	sendEmailPaymentRecieveToGuest(){
		try {
			const data = {
				"reservationId": this.reservations[0].reservationId,
				"orderId": this.order.orderId,
    			"orderInvoiceDetailId" : this.orderInvoiceDetailId
			}
			this.formLoading = true;
			this.orderService.sendEmailPaymentRecieveToGuest(data)
				.subscribe(
					(res: any) => {
						this.formLoading = false;
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						// Do NOT reset formLoading on error — a 504 means the email may have been sent.
						// Keep button disabled to prevent a duplicate email from being triggered.
						console.log('order-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	deleteOrderInvoiceDetailConfirmation() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Order Invoice Detail Id# ' + this.orderInvoiceDetailId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.deleteOrderInvoiceDetail()
				this.visible = false;
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	deleteOrderInvoiceDetail() {
		try {
			this.formLoading = true;
			this.orderService.deleteOrderInvoiceDetail(this.orderInvoiceDetailId)
				.subscribe(
					(res: any) => {
						this.formLoading = false;
						this.reloadPage();
						console.log('order-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Delete order invoice successfully" });
						this.paymentList.forEach((payment, index) => {
							if(payment.orderInvoiceDetailId == this.orderInvoiceDetailId){
								this.paymentList.splice(index, 1);
							}
						});
					},
					(err: any) => {
						// Do NOT reset formLoading on error — keep button disabled to block re-submit after 504.
						console.log('order-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	filterText(text: string) {
		if (text) {
			text = text
				.replace('<br>', '\r')
				.replace('/&lt;br/&gt;', '\r')
				.replace('</p>', '')
				.replace('<br>', '\r')
				.replace(/(?:\r\n|\r|\n|\\r|\\n)/gi, '<br>');
			return text;
		}
		return '';
	}

	updateReservations(){
		this.showValidationErrors = false;
		this.errorMessages = "";
		this.errorList = [];
		this.reservations.forEach((reservation, index) => {
			if(reservation.reservationDirty){
				this.showValidationErrors = false;
				this.formLoading = true;
				this.reservationService.updateGuestInfo(reservation)
				.pipe(first())
				.subscribe(
					res => {
						this.reservations[index].reservationDirty = false;
						this.errorList.push("Reservation "+(index + 1)+" is updated successfully");
						if(this.reservations[index]?.guestProfile?.firstName == null || this.reservations[index]?.guestProfile?.firstName == ""){
							this.errorList.push("  ==> FirstName is required");
						}
						if(this.reservations[index]?.guestProfile?.lastName == null || this.reservations[index]?.guestProfile?.lastName == ""){
							this.errorList.push("  ==> LastName is required");
						}
						if(this.reservations[index]?.guestProfile?.emailAddress == null || this.reservations[index]?.guestProfile?.emailAddress == ""){
							this.errorList.push("  ==> Email Address is required");
						}
						this.errorMessages = "";
						this.showValidationErrors = true;
						for (let i = 0; i < this.errorList.length; i++) {
							this.errorMessages += this.errorList[i] + "\n";
						}
						this.formLoading = false;
						console.log('findReservationById: ' + JSON.stringify(res));
						// this.alertService.success(this.errorMessages, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: this.errorMessages, life: 3000 });
						// this.reservation = res.data.reservation;
						// this.findReservationById();
					},
					err => {
						// Do NOT reset formLoading on error — a 504 means the backend may have already
						// updated the reservation. Keep button disabled to block re-submit.
						this.errorList.push("Reservation "+(index + 1)+" is updated fail");
						console.log('error reservation update: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Reservation update may have completed. Please refresh before retrying.', life: 3000 });
					},
					() => {  });
			}else{
				this.errorList.push("Reservation "+(index + 1)+" is don't have any changes");
			}
			if(this.reservations[index]?.guestProfile?.firstName == null || this.reservations[index]?.guestProfile?.firstName == ""){
				this.errorList.push("  ==> FirstName is required");
			}
			if(this.reservations[index]?.guestProfile?.lastName == null || this.reservations[index]?.guestProfile?.lastName == ""){
				this.errorList.push("  ==> LastName is required");
			}
			if(this.reservations[index]?.guestProfile?.emailAddress == null || this.reservations[index]?.guestProfile?.emailAddress == ""){
				this.errorList.push("  ==> Email Address is required");
			}
		});
		for (let i = 0; i < this.errorList.length; i++) {
			this.errorMessages += this.errorList[i] + "\n";
		}
		var dialogResUpdateInfo = false;
		this.reservations.forEach((reservation, index) => {
			if(reservation.reservationDirty){
				dialogResUpdateInfo = true;
			}
		});
		if(dialogResUpdateInfo == false){
			this.showValidationErrors = true;
		}
	}

	updateOrder() {
		const orderSummaryData = {
			orderId: this.orderId,
			status: this.form1.value.status,
			referralSourceId: this.form1.value.referralSourceId,
			creditSaleTo2: {
				userId : this.form1.value.creditSaleTo2
			},
			creditSaleTo: {
				userId : this.form1.value.creditSaleTo
			},
			orderInvoice: {
				ccPremiumPct: this.form1.value.orderInvoice.ccPremiumPct,
			},
		}

		this.formLoading = true;
		this.orderService.updateOrderSummery(orderSummaryData)
		.subscribe(
				res => {
					this.formLoading = false;
					console.log('findReservationById: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Success', detail: "Order update successfully", life: 3000 });
				},
				err => {
					// Do NOT reset formLoading on error — a 504 means the backend may have
					// already saved the order summary. Keep formLoading=true to block re-submit.
					console.log('error reservation update: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Order update may have completed. Please refresh before retrying.', life: 3000 });
				},
				() => {  });
	}

	doRefreshOrder(){
		this.ngOnInit();
	}

	isPayment(orderInvoiceDetail: any){
		if(orderInvoiceDetail){
			return orderInvoiceDetail?.type == 2 ||	orderInvoiceDetail?.type == 4 || orderInvoiceDetail?.type == 8 ||  orderInvoiceDetail?.type == 9;
		}
		return false;
	}

	redirectToReservations(){
		if(this.searchName != null && this.searchName != undefined && this.searchName != ""){
			// const data ={
			// 	searchName: this.searchName
			// }
			// const formData = JSON.parse(JSON.stringify(data));

			this.router.navigate(['/reservations'], { queryParams: { searchName: this.searchName} });
			this.doUpdate.emit(this.searchName);
		}
	}

	ngOnDestroy(): void {
		// Remove the class from body on component destroy
		this.renderer.removeClass(document.body, 'custom-body-class');
	}

	findReservationById() {
		this.formLoading = true;
		this.reservationService.findById(this.order?.reservations[0]?.reservationId)
			.pipe(first())
			.subscribe(
				res => {
					console.log('findReservationById: ' + JSON.stringify(res));
					this.reservation = res.data.reservation;
					// Find Fees added into the YM price
					this.fetchRateFees(this.reservation?.shortTermRental?.shortTermRentalId, this.reservation?.numNights)

					if(this.reservation?.resRateJson)
					{
						let rateLog = '[' + this.reservation?.resRateJson.replaceAll(/\n\n/g, ',') + ']';
						if (this.isJsonParsable(rateLog))
						{
							this.rateLogOutput = JSON.parse(rateLog);
							const logData = [];
							this.rateLogOutput.forEach(group => {
							  logData.push(...group);
							  logData.push({ isBlankRow: true }); // Add blank row
							});
							this.rateLogOutput = logData;
						}
					}
					if(this.reservation?.resRateLosJson)
					{
						let rateLosLogOutput = '[' + this.reservation?.resRateLosJson.replaceAll(/\n\n/g, ',').replaceAll(/\]\[/g, '],[') + ']';
						if (this.isJsonParsable(rateLosLogOutput))
							{
							this.rateLosLogOutput = JSON.parse(rateLosLogOutput);
							const logData = [];
							this.rateLosLogOutput.forEach(group => {
								logData.push(...group);
								logData.push({ isBlankRow: true }); // Add blank row
							});
							this.rateLosLogOutput = logData;
						}
						else
						{
							console.log("Not a valid JSON string:", this.rateLosLogOutput);
						}
					}

				},
				err => {
					console.log('error In findReservationById is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your reservation: ' + (err?.error?.message || err?.message || 'server error'), life: 5000 });
				},
				() => { this.formLoading = false; });
	}

	fetchRateFees(shortTermRentalId:any, numNights: any)
	{
		this.rateFeesDetails = [];
		if(shortTermRentalId)
		{
			try {
				this.orderDetailService.findNightlyRateFeesOpsNotesDetails(shortTermRentalId, numNights)
					.subscribe(
						(res: any) => {
							console.log('fetchRateFees SUCCESS: ' + JSON.stringify(res));
							this.rateFeesDetails = res.data.addToRateQuote?.orderDetails;
							console.log(this.rateFeesDetails)
						},
						(err: any) => {
							console.log('fetchRateFees FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
	}

	private isJsonParsable(str: string): boolean {
		try {
		  JSON.parse(str);
		  return true;
		} catch (e) {
		  return false;
		}
	  }

  copyUrlToClipboard(orderId: any) {
    const domainUrl = location.origin || 'https://admin.kbmhawaii.com';
    const url = `${domainUrl}/order/${orderId}`;
    navigator.clipboard.writeText(url).then(() => {
      this.isUrlCopied = true;
      setTimeout(() => {
        this.isUrlCopied = false;
      }, 2000);
    }).catch(err => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to copy URL: ' + err, life: 3000 });
    });
  }

  loadUpsellLogs(reservationId: any) {
    if (!reservationId) return;
    this.upsellLogsLoading = true;
    this.upsellLogs = [];
    const filters = {
      referenceId: { value: 'PROMOTION_PRICE', matchMode: 'in' },
      reservationId: { value: reservationId, matchMode: 'in' }
    };
    this.logmanService.findByFilter(0, 200, null, null, [{ field: 'createDate', order: -1 }], null, filters)
      .pipe(first())
      .subscribe(
        res => {
          // The list endpoint now returns the message field directly — no per-item findById needed.
          this.upsellLogs = (res?.data?.logmans || []).filter((l: any) => !!l);
          this.upsellLogsLoading = false;
        },
        err => { this.upsellLogsLoading = false; }
      );
  }

  /**
   * Load the promotion-extension upsell offer for this reservation, if one
   * exists. Backend returns 204 No Content when getPromotionPrice has not
   * produced an offer (or the reservation was never eligible) — service maps
   * that to null so the card simply doesn't render.
   */
  loadPromotionOffer(reservationId: any) {
    if (!reservationId) return;
    this.promotionOfferLoading = true;
    this.promotionOffer = null;
    this.promotionOfferService.getOffer(reservationId).pipe(first()).subscribe(
      offer => {
        this.promotionOffer = offer;
        this.promotionOfferLoading = false;
      },
      () => { this.promotionOfferLoading = false; }
    );
  }

  /**
   * Open the "Preview & Apply" modal — fetches the server-side preview which
   * tells us exactly what will change (new dates, extra-night charge, list
   * price adjustment to enter, coupon policy). Reservationist confirms here
   * before any DB write.
   */
  openPromotionPreview() {
    if (!this.promotionOffer) return;
    // PARTIALLY_APPLIED is also actionable — for dual-direction offers, the
    // reservationist can come back to apply the remaining side within the 72h
    // window. Anything else (APPLIED / DECLINED / EXPIRED / CANCELLED) is final.
    const actionableStatuses = ['OFFERED', 'ACCEPTED', 'PARTIALLY_APPLIED'];
    if (!actionableStatuses.includes(this.promotionOffer.status)) {
      this.messageService.add({
        severity: 'warn', summary: 'Cannot apply',
        detail: `Offer is already ${this.promotionOffer.status} and cannot be applied.`, life: 5000
      });
      return;
    }
    // Initialise direction selection (dual-direction support). Default to all
    // still-unapplied directions; the modal lets the reservationist deselect
    // either side before clicking Apply.
    this.initSelectedDirections();
    this.promotionPreview = null;
    this.promotionPreviewLoading = true;
    this.promotionPreviewVisible = true;
    const dirs = this.selectedDirections.length > 0 ? this.selectedDirections : undefined;
    this.promotionOfferService.previewApply(this.promotionOffer.reservationId, dirs).pipe(first()).subscribe(
      preview => {
        this.promotionPreview = preview;
        this.promotionPreviewLoading = false;
        // Auto-uncheck any directions the backend flagged as blocked.
        this.applyDirectionErrors(preview);
      },
      () => { this.promotionPreviewLoading = false; }
    );
  }

  /**
   * Final confirmation step before Apply runs. Shows a summary popup of the
   * exact reservation + invoice changes the reservationist is about to commit.
   *
   * UX flow:
   *   1. "Preview & Apply" button on the card → opens the preview modal (1st look).
   *   2. "Apply" button inside the preview modal → this method runs.
   *   3. ConfirmationService dialog shows a tight before/after summary + the
   *      key dollar number; reservationist clicks "Yes, Apply" or "Cancel".
   *   4. On accept: runPromotionApply() actually fires the mutation.
   *
   * Two-step confirmation prevents an accidental double-click on the green
   * Apply button from committing changes that touch dates / pricing / coupons.
   */
  confirmPromotionApply() {
    if (!this.promotionOffer || !this.promotionPreview || this.promotionPreview.decision !== 'OK') return;
    // Close the preview dialog FIRST so the confirm dialog is the only modal on screen.
    // If the user cancels we reopen it; if they accept the apply succeeds and closes everything.
    this.promotionPreviewVisible = false;

    const p           = this.promotionPreview;
    const fmt = (d: any) => d ? new Date(d).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }) : '';
    const newCheckIn  = fmt(p.newCheckIn);
    const newCheckOut = fmt(p.newCheckOut);
    const guestTotal  = p.extraNightGuestTotal != null
      ? '$' + p.extraNightGuestTotal.toFixed(2)
      : (p.extraNightDiscounted != null ? '$' + p.extraNightDiscounted.toFixed(2) + ' (YieldMax base)' : '—');
    const newPerNight = p.recommendedListPriceAdjustmentAmount != null
      ? '$' + p.recommendedListPriceAdjustmentAmount.toFixed(2)
      : '—';
    const nights = p.newNights ?? '?';

    // ---- Dual-direction wording (added 2026-05-18) ----
    // Drive the "what changes" sentence from selectedDirections, which is
    // accurate for both legacy single-direction offers and new dual-direction
    // offers. Falls back to the legacy single-direction wording when there's
    // no direction list (very old offers).
    const dirs: string[] = this.selectedDirections.length > 0
        ? this.selectedDirections
        : (this.promotionOffer.directions || (this.promotionOffer.direction ? [this.promotionOffer.direction] : []));
    const applyingBoth = dirs.length === 2 && dirs.indexOf('PREV') >= 0 && dirs.indexOf('NEXT') >= 0;
    const applyingPrev = dirs.length === 1 && dirs[0] === 'PREV';
    const applyingNext = dirs.length === 1 && dirs[0] === 'NEXT';

    // Pretty change-line that names the actual edges being moved
    let changeLine: string;
    if (applyingBoth) {
      changeLine = 'Extend stay by <b>2 nights</b> — one day <b>before check-in</b> and one day <b>after check-out</b> &rarr; ' +
                   'new check-in: <b>' + newCheckIn + '</b>, new check-out: <b>' + newCheckOut + '</b>';
    } else if (applyingPrev) {
      changeLine = 'Extend stay by <b>1 night before check-in</b> &rarr; new check-in: <b>' + newCheckIn + '</b>';
    } else if (applyingNext) {
      changeLine = 'Extend stay by <b>1 night after check-out</b> &rarr; new check-out: <b>' + newCheckOut + '</b>';
    } else {
      changeLine = 'Extend stay &rarr; new check-in: <b>' + newCheckIn + '</b>, new check-out: <b>' + newCheckOut + '</b>';
    }

    // "Adjustment lines" plural for dual, singular for single
    const adjustmentLine = applyingBoth
      ? 'Add <b>two Promotion Extension Discount lines</b> to the invoice (one per added night)'
      : 'Add a <b>Promotion Extension Discount line</b> to the invoice';

    // Decide the post-apply status the row will end up in. APPLIED only when
    // every originally-offered direction is consumed.
    const allOffered: string[] = this.promotionOffer.directions
        || (this.promotionOffer.direction ? [this.promotionOffer.direction] : []);
    const alreadyDone = new Set<string>();
    if (this.isPrevApplied()) alreadyDone.add('PREV');
    if (this.isNextApplied()) alreadyDone.add('NEXT');
    const afterApplyDone = new Set<string>([...alreadyDone, ...dirs]);
    const allWillBeDone  = allOffered.every(d => afterApplyDone.has(d));
    const finalStatus    = allWillBeDone ? 'APPLIED' : 'PARTIALLY_APPLIED';
    const finalStatusLabel = allWillBeDone
      ? 'Mark this offer as <b>APPLIED</b> and notify downstream systems'
      : 'Mark this offer as <b>PARTIALLY APPLIED</b> (the other direction stays available within the 72-hour window) and notify downstream systems';

    // Cost label: "Extra night(s)"
    const costLabel = applyingBoth ? 'Extra nights cost (incl. fees &amp; tax)' : 'Extra night cost (incl. fees &amp; tax)';

    this.confirmationService.confirm({
      header: 'Confirm Apply Promotion',
      icon:   'pi pi-exclamation-triangle',
      message:
        '<div style="line-height: 1.7;">' +
          '<p style="margin: 0 0 8px;"><b>This will permanently change the reservation:</b></p>' +
          '<ul style="margin: 0 0 8px 18px; padding: 0;">' +
            '<li>' + changeLine + '</li>' +
            '<li>' + costLabel + ': <b>' + guestTotal + '</b></li>' +
            (p.couponDiscountPerNight != null ? '<li>Scale the existing coupon line proportionally to ' + nights + ' nights (the guest keeps the coupon benefit on the added night' + (applyingBoth ? 's' : '') + ')</li>' : '') +
            '<li>Scale per-night fees (Resort Fee, etc.) to ' + nights + ' nights</li>' +
            '<li>' + adjustmentLine + '</li>' +
            '<li>' + finalStatusLabel + '</li>' +
          '</ul>' +
          (([1, 7, 11].includes(this.promotionOffer?.referralSourceId))
            ? '<p style="margin: 6px 0 0; color: #1a5c32; font-size: 12px; background:#e8f5e9; padding:6px 8px; border-radius:4px;">' +
                '<i class="pi pi-credit-card"></i> <b>Guest\'s saved card will be charged ' + guestTotal + ' automatically.</b> ' +
                'If the charge is declined you will be notified and can collect via Run Payment.' +
              '</p>'
            : '<p style="margin: 6px 0 0; color: #856404; font-size: 12px; background:#fff3cd; padding:6px 8px; border-radius:4px;">' +
                '<i class="pi pi-exclamation-triangle"></i> <b>No credit card charge is made automatically.</b> ' +
                'Outstanding balance will increase by <b>' + guestTotal + '</b> — collect payment via Run Payment after applying.' +
              '</p>'
          ) +
          '<p style="margin: 4px 0 0; color: #856404; font-size: 11px;">' +
            '<i class="pi pi-info-circle"></i> If anything fails, the offer will NOT be marked ' + finalStatus + '.' +
          '</p>' +
        '</div>',
      acceptLabel:    'Yes, Apply',
      rejectLabel:    'Cancel',
      acceptIcon:     'pi pi-check',
      rejectIcon:     'pi pi-times',
      acceptButtonStyleClass: 'p-button-success',
      rejectButtonStyleClass: 'p-button-secondary p-button-outlined',
      accept: () => { this.runPromotionApply(); },
      reject: () => {
        // Reopen the preview so the reservationist can review again or close manually.
        this.promotionPreviewVisible = true;
        this.messageService.add({ severity: 'info', summary: 'Cancelled', detail: 'Apply cancelled.', life: 3000 });
      }
    });
  }

  /** Actually run the apply — only called from confirmPromotionApply's accept handler. */
  private runPromotionApply() {
    if (!this.promotionOffer) return;
    this.promotionApplying = true;
    const dirs = this.selectedDirections.length > 0 ? this.selectedDirections : undefined;
    this.promotionOfferService.applyOffer(this.promotionOffer.reservationId, dirs).pipe(first()).subscribe(
      result => {
        this.promotionApplying = false;
        this.promotionPreview = result;
        // APPLIED = all originally-offered directions are now applied.
        // PARTIALLY_APPLIED = dual-direction offer; one direction applied,
        // the other still pending (reservationist can return within 72h).
        // Both count as a successful apply for the modal-close UX.
        if (result && (result.offerStatus === 'APPLIED' || result.offerStatus === 'PARTIALLY_APPLIED')) {
          this.promotionPreviewVisible = false;
          // Re-load offer so the card reflects updated status + applied dates.
          this.loadPromotionOffer(this.promotionOffer?.reservationId);
          const guestTotalStr = result.extraNightGuestTotal != null
            ? '$' + result.extraNightGuestTotal.toFixed(2)
            : (result.extraNightDiscounted != null ? '$' + result.extraNightDiscounted.toFixed(2) + ' (YieldMax)' : '—');

          // Build charge result suffix for the toast.
          let chargeMsg = '';
          if (result.chargeAttempted === true) {
            if (result.chargeApproved === true) {
              chargeMsg = ' Card charged ' + (result.chargeAmount != null ? '$' + result.chargeAmount.toFixed(2) : '')
                        + (result.chargeCardMask ? ' (' + result.chargeCardMask + ')' : '')
                        + (result.chargeTransactionId ? ' — Txn#' + result.chargeTransactionId : '') + '.';
            } else {
              chargeMsg = ' ⚠ Charge DECLINED — ' + (result.chargeErrorMessage || 'collect payment via Run Payment.');
            }
          } else {
            chargeMsg = ' No card charged — collect payment via Run Payment.';
          }

          this.messageService.add({
            severity: result.chargeAttempted && result.chargeApproved === false ? 'warn' : 'success',
            summary: 'Promotion applied',
            detail: 'Reservation extended to ' + result.newCheckOut
                  + '. Extra night total: ' + guestTotalStr
                  + '. Nightly rate set to $' + (result.recommendedListPriceAdjustmentAmount || 0).toFixed(2)
                  + ' across all ' + (result.newNights ?? '?') + ' nights.'
                  + chargeMsg
                  + ' Refresh the order to see the updated invoice.',
            life: 10000
          });

          // If charge was declined, show a separate prominent error toast so it is not missed.
          if (result.chargeAttempted === true && result.chargeApproved === false) {
            this.messageService.add({
              severity: 'error',
              summary: 'Card charge declined',
              detail: result.chargeErrorMessage || 'The card charge was declined. Please collect payment manually via Run Payment.',
              life: 12000
            });
          }
          // Race-condition warning: if one direction was selected by the reservationist
          // but got booked between the preview and the apply click, the backend silently
          // drops it and returns directionErrors. Surfacing it here makes it explicit so
          // the reservationist knows why the offer landed in PARTIALLY_APPLIED.
          this.showDirectionSkippedWarnings(result.directionErrors);
          // Reload the order so invoice line items + dates show the new state.
          if (this.order?.orderId) { this.ngOnInit(); }
        } else if (result?.decision === 'CHARGE_FAILED') {
          // Charge was not collected — reservation NOT extended yet.
          // Ask reservationist whether to extend anyway and collect manually.
          this.confirmationService.confirm({
            header: 'Charge failed — extend anyway?',
            message: (result.reason || 'The credit card charge could not be completed.')
                   + '\n\nThe reservation has NOT been extended. Do you want to extend the night anyway and collect payment manually via Run Payment?',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Yes, extend without charge',
            rejectLabel: 'Cancel',
            acceptButtonStyleClass: 'p-button-warning',
            accept: () => { this.runPromotionApplyForce(); },
            reject: () => {
              this.messageService.add({
                severity: 'info', summary: 'Apply cancelled',
                detail: 'Reservation was NOT extended. You can retry Apply when the payment issue is resolved.',
                life: 6000
              });
            }
          });
        } else {
          this.messageService.add({
            severity: 'error', summary: 'Apply failed',
            detail: result?.reason || 'Could not apply offer.', life: 6000
          });
        }
      },
      () => { this.promotionApplying = false; }
    );
  }

  /**
   * Force-apply: extend the reservation without charging the card.
   * Called when reservationist confirms they will collect payment manually
   * after a charge failure.
   */
  private runPromotionApplyForce() {
    if (!this.promotionOffer) return;
    this.promotionApplying = true;
    const dirs = this.selectedDirections.length > 0 ? this.selectedDirections : undefined;
    this.promotionOfferService.applyOfferForce(this.promotionOffer.reservationId, dirs).pipe(first()).subscribe(
      result => {
        this.promotionApplying = false;
        this.promotionPreview = result;
        // Same as runPromotionApply: PARTIALLY_APPLIED also counts as success.
        if (result && (result.offerStatus === 'APPLIED' || result.offerStatus === 'PARTIALLY_APPLIED')) {
          this.promotionPreviewVisible = false;
          this.loadPromotionOffer(this.promotionOffer?.reservationId);
          const guestTotalStr = result.extraNightGuestTotal != null
            ? '$' + result.extraNightGuestTotal.toFixed(2)
            : (result.extraNightDiscounted != null ? '$' + result.extraNightDiscounted.toFixed(2) + ' (YieldMax)' : '—');
          this.messageService.add({
            severity: 'warn',
            summary: 'Promotion applied (no charge)',
            detail: 'Reservation extended to ' + result.newCheckOut
                  + '. Extra night total: ' + guestTotalStr + '.'
                  + ' No card was charged — please collect $' + guestTotalStr + ' manually via Run Payment.',
            life: 12000
          });
          // Race-condition warning: same as runPromotionApply.
          this.showDirectionSkippedWarnings(result.directionErrors);
          if (this.order?.orderId) { this.ngOnInit(); }
        } else {
          this.messageService.add({
            severity: 'error', summary: 'Force-apply failed',
            detail: result?.reason || 'Could not apply offer without charge.', life: 6000
          });
        }
      },
      () => {
        this.promotionApplying = false;
        this.messageService.add({
          severity: 'error', summary: 'Force-apply error',
          detail: 'A network error occurred. Please try again.', life: 6000
        });
      }
    );
  }

  /**
   * Returns true when the offer expires within the next 12 hours.
   * Used to switch the expiry label from amber → red in both the card and preview dialog.
   */
  isOfferExpiringSoon(expiresAt: string): boolean {
    if (!expiresAt) return false;
    const msRemaining = new Date(expiresAt).getTime() - Date.now();
    return msRemaining > 0 && msRemaining < 12 * 60 * 60 * 1000;
  }

  // ============================================================================
  //  Dual-direction selection helpers (added 2026-05-17)
  // ============================================================================

  /** Was the PREV direction originally offered (regardless of applied state)? */
  isPrevSelectable(): boolean {
    if (!this.promotionOffer) return false;
    const dirs = this.promotionOffer.directions;
    return !!(dirs && dirs.indexOf('PREV') >= 0);
  }

  /** Was the NEXT direction originally offered? */
  isNextSelectable(): boolean {
    if (!this.promotionOffer) return false;
    const dirs = this.promotionOffer.directions;
    return !!(dirs && dirs.indexOf('NEXT') >= 0);
  }

  /** Has PREV already been applied on this offer? */
  isPrevApplied(): boolean {
    return !!(this.promotionOffer && this.promotionOffer.prevState && this.promotionOffer.prevState.appliedDate);
  }

  /** Has NEXT already been applied? */
  isNextApplied(): boolean {
    return !!(this.promotionOffer && this.promotionOffer.nextState && this.promotionOffer.nextState.appliedDate);
  }

  /**
   * Toggle a direction's selection in the modal. Re-runs the preview with the
   * new selection so the pricing reflects what will actually be applied.
   */
  toggleDirection(direction: 'PREV' | 'NEXT', event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const set = new Set(this.selectedDirections);
    if (checked) set.add(direction); else set.delete(direction);
    this.selectedDirections = Array.from(set) as ('PREV' | 'NEXT')[];

    // Refresh the preview with the new selection. Empty -> let backend default
    // to "all still-pending" (preview will then show 'BLOCKED' if user unchecks all).
    if (this.promotionOffer && this.selectedDirections.length > 0) {
      this.promotionPreviewLoading = true;
      this.promotionOfferService.previewApply(this.promotionOffer.reservationId, this.selectedDirections)
        .pipe(first()).subscribe(
          preview => {
            this.promotionPreview = preview;
            this.promotionPreviewLoading = false;
            // Auto-uncheck any directions that came back as blocked.
            this.applyDirectionErrors(preview);
          },
          () => { this.promotionPreviewLoading = false; }
        );
    }
  }

  /**
   * Returns true if every originally-offered direction will be applied after
   * this apply runs (i.e. the row will end up in APPLIED status). False means
   * some direction is being skipped this round and the row will be
   * PARTIALLY_APPLIED. Used by the preview-modal copy.
   */
  willBeFullyAppliedAfter(): boolean {
    if (!this.promotionOffer) return false;
    const offered: string[] = this.promotionOffer.directions
      || (this.promotionOffer.direction ? [this.promotionOffer.direction] : []);
    if (offered.length === 0) return true;
    const after = new Set<string>(this.selectedDirections);
    if (this.isPrevApplied()) after.add('PREV');
    if (this.isNextApplied()) after.add('NEXT');
    return offered.every(d => after.has(d));
  }

  /**
   * Initialise selectedDirections when the preview modal opens. For dual-
   * direction offers default to all still-unapplied directions; for single
   * direction default to that one. Called from openPromotionPreview().
   */
  initSelectedDirections(): void {
    if (!this.promotionOffer) {
      this.selectedDirections = [];
      return;
    }
    const dirs = this.promotionOffer.directions || (this.promotionOffer.direction ? [this.promotionOffer.direction] : []);
    const stillPending: ('PREV' | 'NEXT')[] = [];
    for (const d of dirs) {
      if (d === 'PREV' && !this.isPrevApplied()) stillPending.push('PREV');
      if (d === 'NEXT' && !this.isNextApplied()) stillPending.push('NEXT');
    }
    this.selectedDirections = stillPending;
  }

  /**
   * After a preview response comes back, inspect `directionErrors` (populated
   * by the backend when a direction is double-booked). For each blocked direction,
   * auto-uncheck it from `selectedDirections` so the Apply button immediately
   * reflects the available subset without the reservationist having to manually
   * uncheck anything.
   *
   * The HTML conflict-warning block reads `promotionPreview.directionErrors`
   * directly and renders a per-direction explanation.
   */
  private applyDirectionErrors(preview: any): void {
    if (!preview || !preview.directionErrors) return;
    const blockedDirs = Object.keys(preview.directionErrors) as ('PREV' | 'NEXT')[];
    if (blockedDirs.length === 0) return;
    // Remove each blocked direction from the selection.
    this.selectedDirections = this.selectedDirections.filter(d => !blockedDirs.includes(d));
  }

  /**
   * After a successful apply, check whether any directions were silently skipped
   * due to a race condition (night got booked between preview and apply click).
   *
   * Fires a separate amber warning toast per skipped direction so the
   * reservationist clearly understands why the offer is PARTIALLY_APPLIED
   * rather than APPLIED even though they had both nights selected.
   */
  private showDirectionSkippedWarnings(directionErrors?: { [dir: string]: string }): void {
    if (!directionErrors) return;
    const entries = Object.entries(directionErrors);
    if (entries.length === 0) return;
    for (const [dir, msg] of entries) {
      const label = dir === 'PREV' ? 'Day Before Arrival' : 'Day After Departure';
      this.messageService.add({
        severity: 'warn',
        summary: label + ' skipped — conflict detected',
        detail: msg
          + ' This night was booked by another guest between the preview and your Apply click.'
          + ' The remaining direction was applied successfully. You can retry the skipped night if it becomes free again.',
        life: 15000
      });
    }
  }

  /** Mark offer DECLINED from the card — used when guest says no. */
  declinePromotionOffer() {
    if (!this.promotionOffer) return;
    const actionableStatuses = ['OFFERED', 'ACCEPTED'];
    if (!actionableStatuses.includes(this.promotionOffer.status)) {
      this.messageService.add({
        severity: 'warn', summary: 'Cannot decline',
        detail: `Offer is already ${this.promotionOffer.status} and cannot be declined.`, life: 5000
      });
      return;
    }
    if (!confirm('Mark this promotion offer as declined?')) return;
    this.promotionOfferService.declineOffer(this.promotionOffer.reservationId).pipe(first()).subscribe(
      offer => {
        this.promotionOffer = offer;
        if (offer) {
          this.messageService.add({ severity: 'info', summary: 'Declined', detail: 'Offer marked declined.', life: 4000 });
        }
      }
    );
  }
  
  syncOrderWithYieldmax(orderId: any) {
		const data ={
			orderId: orderId
		}
		try {
			this.formLoading = true;
			this.orderService.synchReservationToYieldMaxWithoutSQS(data)
				.subscribe(
					res => {
						this.formLoading = false;
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reservation synced successfully', life: 3000 });
					},
					err => {
						// Do NOT reset formLoading on error — a 504 means the backend may have
						// already synced the reservation. Keep formLoading=true to block re-submit.
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.formLoading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	editPropertyInYieldmax(shortTermRentalId)
	{
		const defaultTabIndx = 0; // or some other dynamic value
		const url = this.router.serializeUrl(
			this.router.createUrlTree([`/yield-max/${defaultTabIndx}/ext/${shortTermRentalId}`])
		);
		// Open the new tab with the constructed URL
  		window.open(url, '_blank');
	}

}
